export default __webpack_public_path__ + "static/media/plus-white.fc63d058.svg";